import { cn } from '@/components/ui/utils';
import { AnimatePresence, HTMLMotionProps, motion } from 'framer-motion';
import React from 'react';

export type TappInputErrorProps = HTMLMotionProps<'div'>;

const TappInputError: React.FC<TappInputErrorProps> = ({ style, className, children, ...props }) => {
  return (
    <AnimatePresence>
      {children && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.15 }}
          className={cn('text-xxs text-destructive first-letter:uppercase', className)}
          {...props}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { TappInputError };
